/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcJpmamV1JpmamOrderEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_JPMAM_V1_JPMAM_ORDER_EVENT_ENTITY_NAME = 'exc.jpmam.v1.JpmamOrderEvent';
export const excJpmamV1JpmamOrderEventEntity = new schema.Entity<ExcJpmamV1JpmamOrderEvent>(EXC_JPMAM_V1_JPMAM_ORDER_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: ExcJpmamV1JpmamOrderEvent) => `${entity.metadata?.eventId}` });

